/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum CallerType {
  FINNAIRCOM = 'FINNAIRCOM',
  MOBILEAPP = 'MOBILEAPP',
  FINNAIR_HOLIDAY = 'FINNAIR_HOLIDAY',
  UNDEFINED = 'UNDEFINED'
}

